import { HTMLAttributes } from 'react'

import Container from '@/components/base/Container'
import Grid from '@/components/base/Grid'
import PushCard, { PushCardProps } from '@/components/base/PushCard'
import Section from '@/components/base/Section'
import Typography, { TypographyProps } from '@/components/base/Typography'

import { cn } from '@/lib/utils'

export type PushCardsProps = HTMLAttributes<HTMLElement> &
  Partial<{
    title: string
    title_variant: TypographyProps['variant']
    title_component: TypographyProps['component']
    cards: PushCardProps[]
  }>

const PushCards = ({
  title,
  title_variant,
  title_component,
  cards = [],
  className,
  ...props
}: PushCardsProps) => {
  return (
    <Section className={cn([className])} {...props}>
      <Container>
        <Grid className="gap-y-gutter">
          {title ? (
            <div className="col-span-4 md:col-span-6 lg:col-span-12">
              <Typography
                variant={title_variant}
                component={title_component}
                className="text-heading"
              >
                {title}
              </Typography>
            </div>
          ) : null}

          {cards?.map((card, index) => (
            <div
              key={`push-card-${index}`}
              className="col-span-4 md:col-span-3 lg:col-span-6"
            >
              <PushCard {...card} />
            </div>
          ))}
        </Grid>
      </Container>
    </Section>
  )
}

export default PushCards
